<template>
  <div class="login">
    <div style="position: absolute; right: 10px; top: 20px; width: 140px">
      <languages />
    </div>
    <img :src="logo" class="logo" />

    <div class="loginForm">
      <el-row style="display: flex">
        <el-col :span="12">
          <div class="formlogo">&nbsp;</div>
        </el-col>
        <el-col :span="12">
          <div class="login_title">{{ $t("login.login_title") }}</div>
          <div class="login_sub_title">{{ $t("login.login_sub_title") }}</div>

          <div class="content" style="
              text-align: center;
              margin-top: 20px;
              padding: 20px 50px 0 50px;
            ">
            <inputitem v-model="login.username" @enter="onLoginClickRSA" :placeholder="$t('login.usernameHolder')"
              icon="icon-icon_login_user" />
            <inputitem v-model="login.password" @enter="onLoginClickRSA" type="password"
              :placeholder="$t('login.passwordHolder')" icon="icon-icon_login_password" />
            <inputitem v-model="login.qym" @enter="onLoginClickRSA" :placeholder="$t('login.qymHolder')"
              icon="icon-icon_login_qym" />
            <inputitem v-model="login.code" :placeholder="$t('login.codeHolder')" icon="icon-icon_login_yzm" append
              @enter="onLoginClickRSA" :appendUrl="checkCodeImg" :title="$t('login.reflush_code')" />
            <div v-if="showDivIf" style="display: flex;align-items: flex-end;flex-direction: row;">
              <inputitem style="width: 65%" v-model="phonecode" :placeholder="$t('login.empty_code')"
                icon="icon-icon_login_qym" />
              <el-button style="width: 35%" @click="startCountdownlogin">{{
                showcoutlogin
              }}</el-button>
            </div>

            <!-- <div v-if="LanguageId == 1" -->
            <div style="text-align: left;margin-top: 10px;display: flex;flex-direction: row;align-items: center;">
              <!--增加用户同意隐私协议-->
              <el-checkbox v-model="login.agree">
              </el-checkbox>
              <div style="margin-left: 10px;">
                <span style="color:#444444;">{{ $t("login.agree") }}</span>
                <span style="color:#2A7AFF;margin-left: 4px;cursor: pointer;" @click="showPrivatePolicy()">{{
                  $t("login.privacy")
                }}</span>
              </div>
            </div>

            <el-row style="width: 100%; margin-top: 20px; display: flex; height: 20px">
              <!--<el-col :span="12" style="text-align: left;"> <el-checkbox
                                    v-model="login.remember">记住我</el-checkbox></el-col>-->
              <el-col :span="24" style="text-align: right">
                <span class="errormsg">{{ errormsg }}</span>
              </el-col>
            </el-row>
            <el-row style="
                width: 100%;
                margin-top: 20px;
                display: flex;
                align-items: center;
                margin-bottom: 40px;
              ">
              <el-col :span="12" style="margin-right: 10px">
                <el-button type="primary" style="width: 100%" @click.native.prevent="onLoginClickRSA"
                  :loading="loading">{{
                    $t("public.login") }}</el-button></el-col>
              <el-col style="margin-left: 10px" :span="12">
                <el-button plain style="width: 100%" @click.native.prevent="onResetClick">{{ $t("public.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <footeritem />
    <el-dialog class="customWidth" :title="$t('login.bindmobile')" :visible.sync="dialogFormVisible"
      :close-on-click-modal="false">
      <el-form :model="newlogin">
        <inputitem v-model="newlogin.phone" :placeholder="$t('vehicle.Mobile')" icon="icon-icon_login_user" />
        <inputitem v-model="newlogin.username" :placeholder="$t('login.usernameHolder')" icon="icon-icon_login_user" />
        <inputitem v-model="newlogin.password" type="password" :placeholder="$t('login.passwordHolder')"
          icon="icon-icon_login_password" />
        <inputitem v-model="newlogin.qym" :placeholder="$t('login.qymHolder')" icon="icon-icon_login_qym" />
        <div>
          <inputitem style="width: 75%" v-model="newlogin.code" :placeholder="$t('login.empty_code')"
            icon="icon-icon_login_qym" />
          <el-button style="width: 25%" @click="startCountdown">{{
            showcout
          }}</el-button>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{
          $t("public.cancel")
        }}</el-button>
        <el-button type="primary" @click="bindphone">{{
          $t("public.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog class="customWidth" title="修改密码" :visible.sync="changepswVisible" :close-on-click-modal="false">
      <el-form :model="changepsw">
        <inputitem v-model="changepsw.phone" :placeholder="$t('vehicle.Mobile')" icon="icon-icon_login_user" />

        <inputitem v-model="changepsw.oldpassword" type="password" :placeholder="$t('changepsw.oldpsw_please')"
          icon="icon-icon_login_password" />
        <inputitem v-model="changepsw.newpassword" type="password" :placeholder="$t('changepsw.newpsw_please')"
          icon="icon-icon_login_password" />
        <inputitem v-model="changepsw.comfirmNewPsw" type="password" :placeholder="$t('changepsw.confirm_please')"
          icon="icon-icon_login_password" />

        <inputitem v-model="changepsw.qym" :placeholder="$t('login.empty_qym')" icon="icon-icon_login_qym" />
        <div v-if="showDivcode">
          <inputitem style="width: 75%" v-model="changepsw.code" :placeholder="$t('login.empty_code')"
            icon="icon-icon_login_qym" />
          <el-button style="width: 25%" @click="startCountdownchange">{{
            showcoutchange
          }}</el-button>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changepswVisible = false">{{
          $t("public.cancel")
        }}</el-button>
        <el-button type="primary" @click="changePsw">{{
          $t("public.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <!--增加隐私协议的显示-->
    <el-dialog :title="$t('login.privacy')" :visible.sync="showPrivateDialog" :close-on-click-modal="false">
      <div style="height: 350px;overflow-y: auto;">
        <div style="padding: 20px; line-height: 24px; text-align: left;" v-html="privateContent">

        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 导入vue-cookies库
import CryptoJS from 'crypto-js';
import inputitem from "./inputitem.vue";
import footeritem from "./footer.vue";
import languages from "./languages.vue";
let Base64 = require("js-base64").Base64;
import settings from "@/settings";
import { validatePassword } from "@/utils/validate";
import JSEncrypt from 'jsencrypt';
import { aes256Encrypt, aes256Decrypt, generateAESKey, rsaEncrypt } from '@/utils/encrypt';
export default {
  components: {
    inputitem,
    footeritem,
    languages,
  },

  computed: {
    checkCodeImg() {
      var timestamp = Date.now();

      //生成4位随机数
      var random = Math.floor(Math.random() * 10000);
      //不足4位，前面补0
      random = random.toString().padStart(4, '0');
      // console.log(random)
      //取时间戳前面3位+随机数+时间戳后面3位
      var timestampRandom = timestamp.toString().substring(0, 3) + random + timestamp.toString().substring(3, 13);
      //将时间戳随机数赋值给headers

      return (
        settings.baseUrl +
        "automatic/v1/Verificode?WebFlag=" +
        this.login.WebFlag
      );
    },
    logo() {
      switch (this.$store.getters.locale) {
        case "en-us":
          return require("@/assets/images/logo_login_en@2x.png");
        case "es-es":
          return require("@/assets/images/logo_login_es@2x.png");

        case "zh-TW":
          return require("@/assets/images/logo_login_cht@2x.png");
      }
      return require("@/assets/images/logo_login_chs@2x.png");
    },
    LanguageId() {
      switch (this.$store.getters.locale) {
        case "en-us":
          return 3;
        case "es-es":
          return 5;
        case "zh-TW":
          return 2;
      }
      return 1;
    },
  },

  data() {
    return {
      showDivIf: false,
      showDivcode: false,
      loading: false,
      showPrivateDialog: false,
      errormsg: "", //错误信息
      login: {
        username: "",
        password: "",
        qym: "",
        code: "",
        remember: false,
        WebFlag: Math.random().toString(),
        LanguageId: 1,
        agree: true
      },
      phonecode: "",
      redirect: undefined,
      otherQuery: {},
      dialogFormVisible: false,
      changepswVisible: false,
      newlogin: {
        phone: "",
        username: "",
        password: "",
        qym: "",
        code: "",
      },
      changepsw: {
        phone: "",
        oldpassword: "",
        newpassword: "",
        comfirmNewPsw: "",
        qym: "",
        code: "",
      },
      filterQYM: "ESD,CLD,MXGG,PED,SGC,CNC,BS,SED",
      showcout: this.$t("login.getcode"),
      countdown: 60,
      timerId: null, // 定义计时器ID变量
      showcoutchange: this.$t("login.getcode"),
      showcoutlogin: this.$t("login.getcode"),
      privateContent: "",//隐私协议内容
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  methods: {
    startCountdownlogin() {
      //如果正在倒计时，不能点了
      if (this.timerId) return;

      if (this.timerId) clearTimeout(this.timerId); // 如果已经有计时器在运行则清除之前的计时器
      this.countdown = 60; // 重置倒计时为60秒
      const interval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--; // 每次减少1秒
          this.showcoutlogin = this.countdown.toString() + "s";
        } else {
          clearInterval(interval); // 当倒计时结束时清除计时器
          this.showcoutlogin = this.$t("login.getcode");
        }
      }, 1000);
      this.timerId = interval; // 将新创建的计时器保存到变量中
      this.sendVerificationCode(this.login.username);
    },
    startCountdown() {
      //如果正在倒计时，不能点了
      if (this.timerId) return;
      if (this.timerId) clearTimeout(this.timerId); // 如果已经有计时器在运行则清除之前的计时器
      this.countdown = 60; // 重置倒计时为60秒
      const interval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--; // 每次减少1秒
          this.showcout = this.countdown.toString() + "s";
        } else {
          clearInterval(interval); // 当倒计时结束时清除计时器
          this.showcout = this.$t("login.getcode");
        }
      }, 1000);
      this.timerId = interval; // 将新创建的计时器保存到变量中
      this.sendVerificationCode(this.newlogin.phone);
    },
    startCountdownchange() {
      if (this.timerId) clearTimeout(this.timerId); // 如果已经有计时器在运行则清除之前的计时器
      this.countdown = 60; // 重置倒计时为60秒
      const interval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--; // 每次减少1秒
          this.showcoutchange = this.countdown.toString() + "s";
        } else {
          clearInterval(interval); // 当倒计时结束时清除计时器
          this.showcoutchange = this.$t("login.getcode");
        }
      }, 1000);
      this.timerId = interval; // 将新创建的计时器保存到变量中
      this.sendVerificationCode(this.changepsw.phone);
    },
    sendVerificationCode(telnumber) {
      this.$api
        .sendVerificationCode({
          TelNumber: telnumber,
        })
        .then((res) => {
          // console.log(res);
          if (res && res.code == 200) {
            this.$message({
              type: "info",
              message: this.$t("login.sendcode_success"),
            });
          }
        });
    },
    bindphone() {
      var newlogin = Object.assign({}, this.newlogin);
      newlogin.password = Base64.encode(this.newlogin.password);

      this.$api
        .bindMobile({
          username: this.newlogin.username,
          password: newlogin.password,
          qym: this.newlogin.qym,
          mobile: this.newlogin.phone,
          vcode: this.newlogin.code,
        })
        .then((res) => {
          console.log(res);
          console.log(res.message);
          console.log(res.code);
          if (res && res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "info",
              message: this.$t("login.bindingsuccessful"),
            });
            this.login.username = this.newlogin.phone;
            this.loading = false;
          } else {
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    changePsw() {
      if (!this.changepsw.oldpassword) {
        this.$message.warning(this.$t("changepsw.oldpsw_please"));
        return;
      }
      if (!this.changepsw.newpassword) {
        this.$message.warning(this.$t("changepsw.newpsw_please"));
        return;
      }
      if (!this.changepsw.comfirmNewPsw) {
        this.$message.warning(this.$t("changepsw.confirm_please"));
        return;
      }
      if (!this.changepsw.code) {
        this.$message.warning(this.$t("login.empty_code"));
        return;
      }
      // if (this.form.newPsw == this.form.oldPsw) {
      //     this.$message.warning('新密码不能和旧密码相同');
      //     return;
      // }
      if (this.changepsw.newpassword != this.changepsw.comfirmNewPsw) {
        this.$message.warning(this.$t("changepsw.newpsw_nosame"));

        return;
      }

      //密码强度验证

      if (!validatePassword(this.changepsw.newpassword)) {
        this.$message.warning(this.$t("changepsw.password_strong"));

        return;
      }
      var changepsw = Object.assign({}, this.changepsw);
      changepsw.oldpassword = Base64.encode(this.changepsw.oldpassword);
      changepsw.newpassword = Base64.encode(this.changepsw.newpassword);
      //修改弱密码
      this.$api
        .changePswByMobile({
          username: this.changepsw.phone,
          oldPsw: changepsw.oldpassword,
          newPsw: changepsw.newpassword,
          qym: changepsw.qym,
          vcode: this.changepsw.code,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.changepswVisible = false;
            this.login.password = this.changepsw.newpassword;
            this.$message({
              type: "info",
              message: this.$t("public.edit_success"),
            });
          } else {
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    onResetClick() {
      this.login.username = "";
      this.login.password = "";
      this.login.qym = "";
      this.login.code = "";
    },
    isPhoneNumber(phone) {
      // if(phone=="18559226478")return false;
      return true;
      // 使用正则表达式进行校验
      const regExp = /^1[3456789]\d{9}$/;
      return regExp.test(phone);
    },
    isPhoneNumberNew(phone) {
      if (phone == "18559226478") return true;
      else return false;

      // 使用正则表达式进行校验
      const regExp = /^1[3456789]\d{9}$/;
      return regExp.test(phone);
    },
    generateMixedRandom() {
      // 定义各类字符集
      const nums = '0123456789';
      const uppers = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const specials = '!#$%&*+,-.:;=?@[]^_`{}~'; // 筛选安全特殊字符
      let result = [];

      // 确保每种类型至少出现一次
      result.push(nums[Math.floor(Math.random() * nums.length)]);
      result.push(uppers[Math.floor(Math.random() * uppers.length)]);
      result.push(specials[Math.floor(Math.random() * specials.length)]);

      // 生成剩余7位字符
      const allChars = nums + uppers + specials;
      for (let i = 3; i < 10; i++) {
        result.push(allChars[Math.floor(Math.random() * allChars.length)]);
      }

      // 随机排序避免固定模式
      return result.sort(() => Math.random() - 0.5).join('');
    },
    async onLoginClickRSA(type) {
      if (this.login.username == "") {
        this.errormsg = this.$t("login.empty_username");
        return;
      }
      if (this.login.password == "") {
        this.errormsg = this.$t("login.empty_password");
        return;
      }
      if (this.login.qym == "") {
        this.errormsg = this.$t("login.empty_qym");
        return;
      }
      if (this.login.code == "") {
        this.errormsg = this.$t("login.empty_code");
        return;
      }

      // if (this.LanguageId == 1 && this.login.agree == false) 
      if (this.login.agree == false) {
        this.$message.warning(this.$t("login.empty_agree"));
        return;
      }


      let qym = this.login.qym.toUpperCase();
      if (
        !this.isPhoneNumber(this.login.username) &&
        this.filterQYM.indexOf(qym) == -1
      ) {
        //判断不是手机号
        this.$confirm(this.$t("login.isbind"), this.$t("public.tips"), {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        })
          .then(() => {
            this.dialogFormVisible = true;
            this.$nextTick(() => {
              this.newlogin.username = this.login.username;
              this.newlogin.password = this.login.password;
              this.newlogin.qym = this.login.qym;
            });
            this.loading = false;
          })
          .catch(() => {

          });
      } else if (
        this.filterQYM.indexOf(qym) != -1 ||
        this.isPhoneNumber(this.login.username)
      ) {
        //判断是否是海外账号/是否是手机号，是访问登录接口
        // var cookiesPhone = "";
        // cookiesPhone = this.$cookies.get('isLoggedIn');
        let lastLoginTime = this.isPhoneNumberNew(this.login.username) ? localStorage.getItem("lastLoginTime") : Date();// localStorage.getItem("lastLoginTime");

        if (lastLoginTime || this.filterQYM.indexOf(qym) != -1) {
          // let newcookiesPhone = Base64.decode(cookiesPhone)
          // if (newcookiesPhone == this.login.username) {
          this.showDivIf = false;
          // }
        } else if (
          !lastLoginTime ||
          Date.now() - lastLoginTime > 30 * 24 * 60 * 60 * 1000
        ) {
          // this.$message('超过30天未登录此设备，请验证手机号');
          this.showDivIf = true;
          if (this.phonecode == "") {
            // this.errormsg = this.$t("login.empty_code");
            this.errormsg = this.$t("login.Verifymobile");
            return;
          } else {
            this.errormsg = "";
          }
          this.$set(this.login, "MobileCode", this.phonecode);
        }

        this.loading = true;
        //去登录
        let timestamp = new Date().getTime();
        let initUniqueIdentifier = timestamp + '2' + this.login.username;
        let R0 = this.generateMixedRandom();
        let R01 = aes256Encrypt(R0, initUniqueIdentifier);
        try {
          let resHandshake1 = await this.$api.handshake1({
            flagD: initUniqueIdentifier,
            ciphertextR01: R01,
          })
          // console.log(resHandshake1);
          if (resHandshake1.code != 200) return new Error("handshake1失败");
          var R03 = resHandshake1.ciphertextR03; // R03是返回的base16密文
          var R11 = resHandshake1.ciphertextR11;
          let R02 = aes256Decrypt(R03, initUniqueIdentifier);
          let R021 = R0.toLowerCase().split('').reverse().join('');
          if (R021 != R02) return;
          let R1 = aes256Decrypt(R11, initUniqueIdentifier);
          let R12 = R1.toLowerCase().split('').reverse().join('');
          let R13 = aes256Encrypt(R12, initUniqueIdentifier);

          let resHandshake2 = await this.$api.handshake2({
            flagD: initUniqueIdentifier,
            ciphertextR13: R13,
          })
          // console.log(resHandshake2);
          if (resHandshake2.code != 200) return new Error("handshake2失败");
          let RU2 = resHandshake2.ciphertextRU2;
          let RSA_RU2 = aes256Decrypt(RU2, initUniqueIdentifier);
          // console.log(RSA_RU2)


          var login = Object.assign({}, this.login);

          if (type == 1) {
            login.WebFlag = '123456';
            login.code = 'longyiapp';
          }
          login.password = Base64.encode(this.login.password);
          login.LanguageId = this.LanguageId;
          var qym_ = this.login.qym.toString();
          qym_ = qym_.toUpperCase();
          // login.AppUseFlag=1;
          let H1 = generateAESKey(JSON.stringify(login));
          let timestamp1 = new Date().getTime();
          let uniqueIdentifier = timestamp1 + '2' + this.login.username;
          let keyA1 = generateAESKey(uniqueIdentifier)
          // console.log(uniqueIdentifier);
          // console.log(keyA1.toString(CryptoJS.enc.Hex));
          // console.log(JSON.stringify(login)+H1);
          let encryptedAES = aes256Encrypt(JSON.stringify(login) + H1, uniqueIdentifier); //AES加密参数
          let encryptedRAS = rsaEncrypt(keyA1.toString(CryptoJS.enc.Base64), RSA_RU2); //RSA公钥加密AES密钥A1，A1要base64 格式

          let resApplogin = {};

          if (type == 1) {
            resApplogin = await this.$api.applogin3({
              flagD: initUniqueIdentifier,
              ciphertextAES: encryptedRAS,
              ciphertextPara: encryptedAES,
            });
          }
          else {
            resApplogin = await this.$api.applogin({
              flagD: initUniqueIdentifier,
              ciphertextAES: encryptedRAS,
              ciphertextPara: encryptedAES,
            });
          }
          //  if(resApplogin.code != 200){
          //    this.loading = false;
          //   // return new Error("applogin失败");
          // } 
          this.loading = false;
          if (resApplogin) {
            // res.code=8;

            if (resApplogin.code != 200 && resApplogin.code != 8) {
              this.$bus.$emit("login-fail");
            }
            switch (resApplogin.code) {
              case 200:
                // //登录成功
                this.$message.success(this.$t("login.login_success"));
                let ciphertextToken = resApplogin.ciphertextToken;

                let decryptedAES = aes256Decrypt(ciphertextToken, uniqueIdentifier);
                let AESres = JSON.parse(decryptedAES);
                // console.log(res);
                AESres.data = Object.assign(
                  {
                    Qym: login.qym,
                    RSAKey: RSA_RU2,
                    flagD: initUniqueIdentifier,
                  },
                  AESres.data,
                );
                console.log("登录成功数据");
                // console.log(JSON.stringify(AESres.data));
                await this.$store.dispatch("user/login", AESres.data);

                await this.$store.dispatch("app/updateSelectedVehicles", []);

                await this.getGasUnit();

                console.log("login-over");
                // this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
                this.$router.push({
                  path: "/",
                });
                // this.$cookies.set('isLoggedIn', newusername);
                localStorage.setItem("lastLoginTime", Date.now());
                break;
              case 8:
                // 弹框确认
                this.$confirm(
                  this.$t("changepsw.changeweakpsw"),
                  this.$t("public.tips"),
                  {
                    confirmButtonText: this.$t("public.confirm"),
                    cancelButtonText: this.$t("public.cancel"),
                    type: "warning",
                  }
                ).then(() => {
                  this.changepswVisible = true;
                  this.$nextTick(() => {
                    this.changepsw.phone = this.login.username;
                    this.changepsw.qym = this.login.qym;
                  });
                  if (this.isPhoneNumber(this.login.username)) {
                    this.showDivcode = true;
                    this.countdown = 0;
                    this.showcoutlogin = this.$t("login.getcode");
                  } else {
                    this.showDivcode = false;
                  }
                });

                break;
              case 4:
                this.errormsg = this.$t("login.pswerror");

                break;
              case 5:
                this.errormsg = this.$t("login.error_code");
                break;
              case 7:

                this.errormsg = this.$t("login.error_qym");

                break;
              case 0:
              case 1:
              case 2:

                this.errormsg = this.$t("login.error_usernameorpsw");

                break;
              case 9:
                this.errormsg = this.$t("login.accountlocked");


                break;
              case 10:

                this.errormsg = this.$t("login.error_phonecode");

                break;
            }
          }

        } catch (error) {
          console.log(error);
        }

        return;
        this.$api.handshake1({
          flagD: initUniqueIdentifier,
          ciphertextR01: R01,
        })
          .then((res) => {
            var R03 = res.ciphertextR03; // R03是返回的base16密文
            var R11 = res.ciphertextR11;
            let R02 = aes256Decrypt(R03, initUniqueIdentifier);
            let R021 = R0.toLowerCase().split('').reverse().join('');
            if (R021 != R02) return;
            let R1 = aes256Decrypt(R11, initUniqueIdentifier);
            let R12 = R1.toLowerCase().split('').reverse().join('');
            let R13 = aes256Encrypt(R12, initUniqueIdentifier);
            this.$api.handshake2({
              flagD: initUniqueIdentifier,
              ciphertextR13: R13,
            })
              .then((res) => {
                let RU2 = res.ciphertextRU2;
                let RSA_RU2 = aes256Decrypt(RU2, initUniqueIdentifier);
                // console.log(RSA_RU2)
                var login = Object.assign({}, this.login);
                login.password = Base64.encode(this.login.password);
                login.LanguageId = this.LanguageId;
                var qym = this.login.qym.toString();
                qym = qym.toUpperCase();
                // login.AppUseFlag=1;

                let H1 = generateAESKey(JSON.stringify(login));
                let timestamp1 = new Date().getTime();
                let uniqueIdentifier = timestamp1 + '2' + this.login.username;
                let keyA1 = generateAESKey(uniqueIdentifier)
                // console.log(uniqueIdentifier);
                // console.log(keyA1.toString(CryptoJS.enc.Hex));
                // console.log(JSON.stringify(login)+H1);
                let encryptedAES = aes256Encrypt(JSON.stringify(login) + H1, uniqueIdentifier); //AES加密参数
                let encryptedRAS = rsaEncrypt(keyA1.toString(CryptoJS.enc.Base64), RSA_RU2); //RSA公钥加密AES密钥A1，A1要base64 格式
                this.$api.applogin({
                  flagD: initUniqueIdentifier,
                  ciphertextAES: encryptedRAS,
                  ciphertextPara: encryptedAES,
                })
                  .then(async (res) => {
                    this.loading = false;

                    if (res) {
                      // res.code=8;

                      if (res.code != 200 && res.code != 8) {
                        this.$bus.$emit("login-fail");
                      }
                      switch (res.code) {
                        case 200:
                          // //登录成功
                          this.$message.success(this.$t("login.login_success"));
                          let ciphertextToken = res.ciphertextToken;

                          let decryptedAES = aes256Decrypt(ciphertextToken, uniqueIdentifier);
                          let AESres = JSON.parse(decryptedAES);
                          // console.log(res);
                          AESres.data = Object.assign(
                            {
                              Qym: login.qym,
                              RSAKey: RSA_RU2,
                              flagD: initUniqueIdentifier,
                            },
                            AESres.data,
                          );
                          console.log("登录成功数据");
                          // console.log(JSON.stringify(AESres.data));
                          await this.$store.dispatch("user/login", AESres.data);

                          await this.$store.dispatch("app/updateSelectedVehicles", []);

                          await this.getGasUnit();

                          console.log("login-over");
                          // this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
                          this.$router.push({
                            path: "/",
                          });
                          // this.$cookies.set('isLoggedIn', newusername);
                          localStorage.setItem("lastLoginTime", Date.now());
                          break;
                        case 8:
                          // 弹框确认
                          this.$confirm(
                            this.$t("changepsw.changeweakpsw"),
                            this.$t("public.tips"),
                            {
                              confirmButtonText: this.$t("public.confirm"),
                              cancelButtonText: this.$t("public.cancel"),
                              type: "warning",
                            }
                          ).then(() => {
                            this.changepswVisible = true;
                            this.$nextTick(() => {
                              this.changepsw.phone = this.login.username;
                              this.changepsw.qym = this.login.qym;
                            });
                            if (this.isPhoneNumber(this.login.username)) {
                              this.showDivcode = true;
                              this.countdown = 0;
                              this.showcoutlogin = this.$t("login.getcode");
                            } else {
                              this.showDivcode = false;
                            }
                          });

                          break;
                        case 4:
                          this.errormsg = this.$t("login.pswerror");

                          break;
                        case 5:
                          this.errormsg = this.$t("login.error_code");
                          break;
                        case 7:

                          this.errormsg = this.$t("login.error_qym");

                          break;
                        case 0:
                        case 1:
                        case 2:

                          this.errormsg = this.$t("login.error_usernameorpsw");

                          break;
                        case 9:
                          this.errormsg = this.$t("login.accountlocked");


                          break;
                        case 10:

                          this.errormsg = this.$t("login.error_phonecode");

                          break;
                      }
                    }

                  })
                  .catch((res) => {
                    console.log(res);
                    this.loading = false;
                  });
              })
          })
      }
    },
    async getGasUnit() {
      this.$api.queryTemplateConfigApp({})
        .then(async (res) => {
          if (res.code == 200) {
            let unit = "kg";
            unit = res.data.GasUnit;
            if (unit == "") {
              unit = "kg";
            }
            await this.$store.dispatch("user/setGasUnit", unit);
            return unit;
          }
        })
        .catch((e) => {

        })
    },
    onLoginClick() {
      if (this.login.username == "") {
        this.errormsg = this.$t("login.empty_username");
        return;
      }
      if (this.login.password == "") {
        this.errormsg = this.$t("login.empty_password");
        return;
      }
      if (this.login.qym == "") {
        this.errormsg = this.$t("login.empty_qym");
        return;
      }
      if (this.login.code == "") {
        this.errormsg = this.$t("login.empty_code");
        return;
      }

      if (this.LanguageId == 1 && this.login.agree == false) {
        this.$message.warning(this.$t("login.empty_agree"));
        return;
      }

      var login = Object.assign({}, this.login);
      login.password = Base64.encode(this.login.password);
      const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyDzBSBFntiR0ZLx8Yo1Gk+9av2Hhqa1BnkcAuL8TjMpEjTeNzfHX73v1pZ7Sn3A7yOpz+lPVNk2vywhPqMzcIGPM5ej8QOOVVYkRw1LkOTtVSOfWP5Zrq+e/kQqssqy6kj4qS68El8TcGQZ8yBVVMmBcxJKWTtvnsj99a9Ovqn0aNcwn0+KOJLYssSRxtaGH0PvuSHYFgGvh7QRqJOvd/KTKn3oFkD4sZgujL6aBLCUAZ7igbsphqDhRtKsVjSMNQwpR730ujApMwUKull+ZHCxakESp+LNvIaabcyaAgpbUNfuTm8sPmS3NM2GtqjKWZQ8Ht8lyBfOetjxAOdYDhQIDAQAB
-----END PUBLIC KEY-----`;

      //base64编码
      var password = login.password
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      //  login.password = encrypt.encrypt(password);
      login.LanguageId = this.LanguageId;
      var newusername = Base64.encode(this.login.username);
      var qym = this.login.qym.toString();
      qym = qym.toUpperCase();
      // console.log(qym);
      // this.loading = true;
      if (
        !this.isPhoneNumber(this.login.username) &&
        this.filterQYM.indexOf(qym) == -1
      ) {
        //判断不是手机号
        this.$confirm(this.$t("login.isbind"), this.$t("public.tips"), {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        })
          .then(() => {
            this.dialogFormVisible = true;
            this.$nextTick(() => {
              this.newlogin.username = this.login.username;
              this.newlogin.password = this.login.password;
              this.newlogin.qym = this.login.qym;
            });
            this.loading = false;
          })
          .catch(() => {

          });
      } else if (
        this.filterQYM.indexOf(qym) != -1 ||
        this.isPhoneNumber(this.login.username)
      ) {
        //判断是否是海外账号/是否是手机号，是访问登录接口
        // var cookiesPhone = "";
        // cookiesPhone = this.$cookies.get('isLoggedIn');
        let lastLoginTime = localStorage.getItem("lastLoginTime");

        if (lastLoginTime || this.filterQYM.indexOf(qym) != -1) {
          // let newcookiesPhone = Base64.decode(cookiesPhone)
          // if (newcookiesPhone == this.login.username) {
          this.showDivIf = false;
          // }
        } else if (
          !lastLoginTime ||
          Date.now() - lastLoginTime > 30 * 24 * 60 * 60 * 1000
        ) {
          // this.$message('超过30天未登录此设备，请验证手机号');
          this.showDivIf = true;
          if (this.phonecode == "") {
            // this.errormsg = this.$t("login.empty_code");
            this.errormsg = this.$t("login.Verifymobile");
            return;
          } else {
            this.errormsg = "";
          }
          this.$set(login, "MobileCode", this.phonecode);
        }

        this.loading = true;
        //去登录
        this.$api
          .opelogin(login)
          .then(async (res) => {
            console.log(res);
            this.loading = false;
            if (res) {
              // res.code=8;

              if (res.code != 200 && res.code != 8) {
                this.$bus.$emit("login-fail");
              }
              switch (res.code) {
                case 200:
                  // //登录成功
                  this.$message.success(this.$t("login.login_success"));
                  res.data = Object.assign(
                    {
                      Qym: login.qym,
                    },
                    res.data
                  );
                  await this.$store.dispatch("user/login", res.data);

                  await this.$store.dispatch("app/updateSelectedVehicles", []);
                  console.log("login-over");
                  // this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
                  this.$router.push({
                    path: "/",
                  });
                  // this.$cookies.set('isLoggedIn', newusername);
                  localStorage.setItem("lastLoginTime", Date.now());
                  break;
                case 8:
                  // 弹框确认
                  this.$confirm(
                    this.$t("changepsw.changeweakpsw"),
                    this.$t("public.tips"),
                    {
                      confirmButtonText: this.$t("public.confirm"),
                      cancelButtonText: this.$t("public.cancel"),
                      type: "warning",
                    }
                  ).then(() => {
                    this.changepswVisible = true;
                    this.$nextTick(() => {
                      this.changepsw.phone = this.login.username;
                      this.changepsw.qym = this.login.qym;
                    });
                    if (this.isPhoneNumber(this.login.username)) {
                      this.showDivcode = true;
                      this.countdown = 0;
                      this.showcoutlogin = this.$t("login.getcode");
                    } else {
                      this.showDivcode = false;
                    }
                  });

                  break;
                case 4:
                  this.errormsg = this.$t("login.pswerror");

                  break;
                case 5:
                  this.errormsg = this.$t("login.error_code");
                  break;
                case 7:

                  this.errormsg = this.$t("login.error_qym");

                  break;
                case 0:
                case 1:
                case 2:

                  this.errormsg = this.$t("login.error_usernameorpsw");

                  break;
                case 9:
                  this.errormsg = this.$t("login.accountlocked");


                  break;
                case 10:

                  this.errormsg = this.$t("login.error_phonecode");

                  break;
              }
            }
          })
          .catch((res) => {
            console.log(res);
            this.loading = false;
          });
      }
    },
    showPrivatePolicy() {
      this.showPrivateDialog = true;
      this.queryPrivacyPolicy();
    },
    queryPrivacyPolicy() {
      this.$api
        .QueryPrivacyPolicy({
          Flag: 1,//需要增加多语言
          LanguageID: this.LanguageId
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.privateContent = res.Content;
          }
        });
    }
  },
  mounted() {
    const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }

    // 检查URL参数是否包含登录信息
    const query = this.$route.query;
    
    if (query.username || query.password || query.qym) {
      // 如果URL中包含登录参数，设置对应的值
      if (query.username) {
        this.login.username = decodeURIComponent(query.username);
      }
      if (query.password) {
        this.login.password = decodeURIComponent(query.password);
      }
      if (query.qym) {
        this.login.qym = decodeURIComponent(query.qym);
      }

      // this.login.WebFlag = '123456'; 不能改
      this.login.code = 'longyiapp';

      // 登录
      this.onLoginClickRSA(1);
    }
  },
};
</script>
<style lang="scss" scoped>
.customWidth {
  ::v-deep .el-dialog {
    width: 500px;
  }
}

.login {
  text-align: center;
  width: 100%;
  overflow: auto !important;
  height: 100%;
  background-image: url("~@/assets/images/bg_login@1x.jpg");
  background-repeat: no-repeat;
  background-color: #2d4c7f;

  .formlogo {
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/images/img_login@2x.jpg");
    border-radius: 15px 0 0 15px;
    // background-repeat: repeat-y;
    background-size: cover;
  }

  .errormsg {
    font-size: 13px;
    color: #ff3333;
    letter-spacing: 0;
    text-align: right;
  }

  .logo {
    // width: 380px;
    margin-top: 60px;
    height: 65px;
  }

  ::v-deep {
    .el-input--prefix .el-input__inner {
      padding-left: 45px;
    }

    .el-input__icon {
      border-right: 1px solid #dddddd;
      padding-right: 10px;
      font-size: 20px;
    }

    .el-input {
      margin-top: 10px;
    }
  }

  .loginForm {
    width: 840px;
    background: #f4f8ff;
    border-radius: 15px;
    margin: 0 auto;

    margin-top: 60px;

    .login_title {
      font-size: 28px;
      color: #444444;
      margin-top: 40px;
    }

    .login_sub_title {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
  }
}
</style>
